import { Components, Theme } from '@mui/material/styles';

export const tooltipTheme: Components<Theme>['MuiTooltip'] = {
  // styleOverrides: {},
  // variants: [],
};
